<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" name="reportSpinner" size = "medium" color = "#fff" type = "ball-rotate" [fullScreen] = "false"><p style="color: white" > Generando Reporte... </p></ngx-spinner>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" name="exportReponnerSpinner" size = "medium" color = "#fff" type = "ball-rotate" [fullScreen] = "false"><p style="color: white" > {{ progressMessage }} </p></ngx-spinner>

<!-- CONFIRMACION DE REPORTE (ELEGIR UN TIPO) -->
<p-confirmDialog #cdExport [style]="{width: '30rem'}" [closeOnEscape]="true" [breakpoints]="{'960px': '50vw', '640px': '75vw'}" class="gl-confirm-dialog " key="showSelectExcelConfirmation">
  <ng-template pTemplate="header">
      <h4>Elija un formato para exportar</h4>
      <div class="p-dialog-header-icons confirm-dialog-close-button">
        <button type="button" class="p-dialog-header-icon p-dialog-header-close p-link" (click)="cdExport.close($event)">
          <span class="pi pi-times"></span>
        </button>
      </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="col-4">
      <button type="button" class="btn-gl-neutral btn-neutral-hover btn-sm w-100" (click)="configReporteUnido(); cdExport.accept()">Unido</button>
    </div>
    <div class="col-4">
      <button type="button" class="btn-gl-neutral btn-neutral-hover btn-sm w-100" (click)="configReporteSeparado(); cdExport.accept()">Separado</button>
    </div>
  </ng-template>
</p-confirmDialog>



<div style="display: flex; flex-direction: column; padding: 0; height: 100%; max-height: 100%; margin: 0; font-size: 0.8rem;">

  <!-- HEADER REPORT -->
  <div *ngIf="!report_completed" class="pristine-report">
    <img src="./assets/images/fondo-svg-reporte.svg" alt="fondo-reporte-logo">
  </div>
  <div *ngIf="report_completed && reportPayload" class="container grand-container">
    <div class="table-title p-card" style="margin-bottom: 0.25rem;">{{reportPayload.reportDetails.title}} <span style="font-size: 1.5rem;"> {{ reportPayload.eventConfig.selectedEventNames }}</span> </div>

    <div class="table-subtitle p-card" style="margin-bottom: 0.25rem;">{{ reportPayload.reportDetails.subtitle }}</div>
  </div>

  <!-- BODY REPORT -->
  <ng-container *ngIf="reportPayload != null && showReport">
    <div class="container grand-container multitable-container" >

      <ng-container [ngSwitch]="reportCategory">

        <!-- Deprecated -->
        <div *ngSwitchCase="'deprecated'"
            style="padding: 12px; background-color: #fff3cd; color: #856404; border: 1px solid #ffeeba; border-radius: 6px; font-weight: 500; margin: 10px 0;">
          ⚠️ Este reporte ha sido <strong>deprecado</strong> y podría no estar disponible próximamente.
        </div>

        <app-report-basic  *ngSwitchCase="Categories.BASE"
          [report]="reportPayload"
          [columns]="reportColumns"
          [category]="reportCategory">
        </app-report-basic>

        <app-report-vehicles  *ngSwitchCase="Categories.VEHICLE"
          [report]="reportPayload"
          [category]="reportCategory"
          [columns]="reportColumns">
        </app-report-vehicles>

        <app-report-events  *ngSwitchCase="Categories.EVENT"
          [report]="reportPayload"
          [category]="reportCategory"
          [columns]="reportColumns">
        </app-report-events>

        <!-- Default -->
        <div *ngSwitchDefault>
          ⚠️ Este tipo de reporte no tiene soporte.
        </div>

      </ng-container>
    </div>
  </ng-container>




  <div class="export-container" *ngIf="reportPayload">
    <ng-container *ngIf="reportPayload.permission && reportPayload.permission.export">
      <ng-container>
        <ng-container *appHasPermission="reportPayload.permission.export.excel">
          <button
              class="btn btn-gl btn-success btn-dark-hover"
              (click)="exportReport('excel')">
            EXPORTAR EXCEL
          </button>
        </ng-container>
      </ng-container>

      <ng-container>
        <ng-container *appHasPermission="reportPayload.permission.export.pdf">
          <button
              class="btn btn-gl btn-gl-red btn-dark-hover"
              (click)="exportReport('pdf')">
            EXPORTAR PDF
          </button>
        </ng-container>
      </ng-container>

      <ng-container>
        <ng-container *appHasPermission="reportPayload.permission.export.html">
          <button
              class="btn btn-gl btn-gl-red btn-dark-hover"
              style="background-color: #fd7e14;"
              (click)="exportReport('html')">
            EXPORTAR HTML
          </button>
        </ng-container>
      </ng-container>

    </ng-container>
  </div>
</div>


